import * as React from 'react';
import Svg, {
  SvgProps, Path, Line, G, Defs, Rect,
} from 'react-native-svg';

const SunnyIcon = (props: SvgProps) => <Svg
  width={32}
  height={32}
  viewBox='0 0 32 32'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M23.3346 16.0003C23.3346 20.0504 20.0514 23.3337 16.0013 23.3337C11.9512 23.3337 8.66797 20.0504 8.66797 16.0003C8.66797 11.9502 11.9512 8.66699 16.0013 8.66699C20.0514 8.66699 23.3346 11.9502 23.3346 16.0003Z'
    stroke='#003A70'
    strokeWidth='1.5'
  />
  <Line
    x1='28.5859'
    y1='16.084'
    x2='26.0859'
    y2='16.084'
    stroke='#003A70'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round' />
  <Line x1='5.91797' y1='16.084' x2='3.41797' y2='16.084' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  <G clipPath='url(#clip0_2079_86517)'>
    <Line x1='26.8544' y1='22.3644' x2='24.6893' y2='21.1144' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip1_2079_86517)'>
    <Line x1='7.22548' y1='11.0314' x2='5.06042' y2='9.78135' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip2_2079_86517)'>
    <Line x1='22.2216' y1='26.9393' x2='20.9716' y2='24.7743' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip3_2079_86517)'>
    <Line x1='10.8895' y1='7.30947' x2='9.63954' y2='5.1444' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip4_2079_86517)'>
    <Line x1='15.9141' y1='28.584' x2='15.9141' y2='26.084' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip5_2079_86517)'>
    <Line x1='15.9141' y1='5.91699' x2='15.9141' y2='3.41699' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip6_2079_86517)'>
    <Line x1='9.63564' y1='26.8554' x2='10.8856' y2='24.6903' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip7_2079_86517)'>
    <Line x1='20.9716' y1='7.22548' x2='22.2216' y2='5.06042' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip8_2079_86517)'>
    <Line x1='5.05968' y1='22.2196' x2='7.22474' y2='20.9696' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <G clipPath='url(#clip9_2079_86517)'>
    <Line x1='24.6886' y1='10.8856' x2='26.8536' y2='9.63564' stroke='#003A70' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </G>
  <Path d='M22.6693 16.0007C22.6693 19.6825 19.6845 22.6673 16.0026 22.6673C12.3207 22.6673 9.33594 19.6825 9.33594 16.0007C9.33594 12.3188 12.3207 9.33398 16.0026 9.33398C19.6845 9.33398 22.6693 12.3188 22.6693 16.0007Z' fill='#F7C25D' />
  <Defs>
    <clipPath id='clip0_2079_86517'>
      <Rect x='24.1719' y='19.1787' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(30 24.1719 19.1787)' fill='white' />
    </clipPath>
    <clipPath id='clip1_2079_86517'>
      <Rect x='4.54297' y='7.8457' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(30 4.54297 7.8457)' fill='white' />
    </clipPath>
    <clipPath id='clip2_2079_86517'>
      <Rect x='21.4883' y='22.8389' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(60 21.4883 22.8389)' fill='white' />
    </clipPath>
    <clipPath id='clip3_2079_86517'>
      <Rect x='10.1562' y='3.20898' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(60 10.1562 3.20898)' fill='white' />
    </clipPath>
    <clipPath id='clip4_2079_86517'>
      <Rect x='17.332' y='24.667' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(90 17.332 24.667)' fill='white' />
    </clipPath>
    <clipPath id='clip5_2079_86517'>
      <Rect x='17.332' y='2' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(90 17.332 2)' fill='white' />
    </clipPath>
    <clipPath id='clip6_2079_86517'>
      <Rect x='12.8203' y='24.1719' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(120 12.8203 24.1719)' fill='white' />
    </clipPath>
    <clipPath id='clip7_2079_86517'>
      <Rect x='24.1562' y='4.54199' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(120 24.1562 4.54199)' fill='white' />
    </clipPath>
    <clipPath id='clip8_2079_86517'>
      <Rect x='9.16016' y='21.4883' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(150 9.16016 21.4883)' fill='white' />
    </clipPath>
    <clipPath id='clip9_2079_86517'>
      <Rect x='28.7891' y='10.1543' width='5.33333' height='2.66667' rx='1.33333' transform='rotate(150 28.7891 10.1543)' fill='white' />
    </clipPath>
  </Defs>
</Svg>;

export default SunnyIcon;
